import React from 'react';
import { images } from '../../shared/assets';
import './DestinationsGallery.css';

const DestinationsGallery: React.FC = () => {
  return (
    <div className="destination-gallery-section" data-name="Destination Gallery" id="node-503_6468">
      <div className="gallery-container">
        <h2>Urna et faucibus tellus</h2>
        
        <div className="gallery-grid">
          {/* Card 1 */}
          <div className="gallery-card" data-name="Card 1" id="node-503_6474">
            <div className="gallery-image-container">
              <img 
                src={images.destinationsPage.figmaAssets.galleryCard1} 
                alt="Awasi Torres del Paine"
                className="gallery-image"
              />
              <div className="gallery-tag">
                <span>Chile</span>
              </div>
            </div>
            <div className="gallery-text">
              <h3>Awasi Torres del Paine</h3>
            </div>
          </div>

          {/* Card 2 */}
          <div className="gallery-card" data-name="Card 2" id="node-503_6475">
            <div className="gallery-image-container">
              <img 
                src={images.destinationsPage.figmaAssets.galleryCard2} 
                alt="Awasi Lorem Ipsum"
                className="gallery-image"
              />
              <div className="gallery-tag">
                <span>patagonia</span>
              </div>
            </div>
            <div className="gallery-text">
              <h3>Awasi Lorem Ipsum</h3>
            </div>
          </div>

          {/* Card 3 */}
          <div className="gallery-card" data-name="Card 3" id="node-503_6476">
            <div className="gallery-image-container">
              <img 
                src={images.destinationsPage.figmaAssets.galleryCard3} 
                alt="Awasi Lorem Ipsum"
                className="gallery-image"
              />
              <div className="gallery-tag">
                <span>iguazu</span>
              </div>
            </div>
            <div className="gallery-text">
              <h3>Awasi Lorem Ipsum</h3>
            </div>
          </div>

          {/* Card 4 - Una Coming Soon */}
          <div className="gallery-card gallery-card--coming-soon" data-name="Card 4" id="node-503_6477">
            <div className="gallery-image-container">
              <img 
                src={images.destinationsPage.figmaAssets.galleryCard1} 
                alt="Awasi Una - Coming Soon"
                className="gallery-image"
              />
              <div className="gallery-tag gallery-tag--coming-soon">
                <span>COMING SOON</span>
              </div>
            </div>
            <div className="gallery-text">
              <h3>Awasi Una</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DestinationsGallery;